export default 'https://api.tria.health'